var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-35px 0 0 40px",
      "font-weight": "600"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "margin-top": "-2px"
    },
    attrs: {
      "src": require("../../../assets/icon/返回.png")
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v("\n\t\t回款管理\n\t")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#fdfdfd",
      "padding": "30px 50px",
      "border": "1px solid #f7f7f7"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("公司名头：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.partnerName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("组织架构：")]), _c('span', [_vm._v(_vm._s(_vm.$globals.group_name) + "/" + _vm._s(_vm.manageList.organizeName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("区域总管：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.areaManagerName))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.projectName))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("履约金额：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.money_amount))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("未回款金额：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.uncollected_payment_money))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("是否散场备注：")]), _c('span', [_vm._v(_vm._s(''))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("收据情况：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.is_receipt == '1' ? '有' : '无'))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("备注：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.spare))])]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("项目名称：")]), _c('span', [_vm._v(_vm._s(_vm.manageList.projectName))])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 2%",
      "font-size": "18px",
      "font-weight": "600"
    }
  }, [_vm._v("付款记录")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "-2% 2% 0 2%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#ebf7f3',
        color: '#000000'
      },
      "data": _vm.payData,
      "tooltip-effect": "dark",
      "height": "200"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payment_time",
      "label": "付款时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "collection_voucher",
      "label": "付款凭证",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/查看.png")
          },
          on: {
            "click": function($event) {
              return _vm.Voucher()
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "money_amount",
      "label": "付款金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "付款类别",
      "align": "center"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 50px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px",
      "margin-left": "10px"
    }
  }, [_vm._v("回款日期")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "type": "datetimerange",
      "clearable": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "format": "yyyy-MM-dd HH:mm",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd HH:mm"
    },
    model: {
      value: (_vm.condition.start_date),
      callback: function($$v) {
        _vm.$set(_vm.condition, "start_date", $$v)
      },
      expression: "condition.start_date"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "height": "41px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "135px",
      "height": "41px"
    },
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Plan
    }
  }, [_vm._v("回款计划登记")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "3% 2% 0 2%"
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#F0F0F0',
        color: '#000000'
      },
      "data": _vm.tableData,
      "tooltip-effect": "dark",
      "height": "420"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "estimate_collection_date",
      "label": "预计回款时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "estimate_collection_amount",
      "label": "预计回款金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reality_collection_date",
      "label": "实际回款日期",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reality_collection_amount",
      "label": "实际回款金额",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "collection_voucher",
      "label": "回款凭证",
      "align": "center",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/查看.png")
          },
          on: {
            "click": function($event) {
              return _vm.Voucher()
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spare",
      "label": "备注",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "applicantName",
      "label": "操作人",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "modified_time",
      "label": "操作时间",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          attrs: {
            "src": require("../../../assets/icon/回款登记1.png")
          },
          on: {
            "click": function($event) {
              return _vm.Update(scope.row.id)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/icon/修改.png")
          },
          on: {
            "click": function($event) {
              return _vm.Revise(scope.row)
            }
          }
        }), _vm._v(" "), _c('img', {
          attrs: {
            "src": require("../../../assets/icon/删除.png")
          },
          on: {
            "click": function($event) {
              return _vm.Del(scope.row.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-left": "500px",
      "margin-top": "-20px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.plan.id == null || _vm.plan.id == '' ? '回款计划登记' : '回款计划修改',
      "visible": _vm.showPlan,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showPlan = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "120px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "预计回款时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.plan.estimate_collection_date),
      callback: function($$v) {
        _vm.$set(_vm.plan, "estimate_collection_date", $$v)
      },
      expression: "plan.estimate_collection_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预计回款金额"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入预计回款金额"
    },
    model: {
      value: (_vm.plan.estimate_collection_amount),
      callback: function($$v) {
        _vm.$set(_vm.plan, "estimate_collection_amount", $$v)
      },
      expression: "plan.estimate_collection_amount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.plan.id == null || _vm.plan.id == '') ? _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.PlanSave()
      }
    }
  }, [_vm._v("保存\n\t\t\t\t\t\t")]) : _c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.ReviseSave()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "回款登记",
      "visible": _vm.showRegister,
      "width": "30%",
      "center": "true",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showRegister = $event
      }
    }
  }, [_c('div', [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "120px",
      "model": _vm.formLabelAlign
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "实际回款时间"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.register.reality_collection_date),
      callback: function($$v) {
        _vm.$set(_vm.register, "reality_collection_date", $$v)
      },
      expression: "register.reality_collection_date"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "实际回款金额"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "请输入实际回款金额"
    },
    model: {
      value: (_vm.register.reality_collection_amount),
      callback: function($$v) {
        _vm.$set(_vm.register, "reality_collection_amount", $$v)
      },
      expression: "register.reality_collection_amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "回款凭证"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$globals.http + '/file/upload',
      "show-file-list": false,
      "on-success": _vm.handlePhotoSuccess
    }
  }, [(_vm.register.collection_voucher) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.register.collection_voucher
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.register.spare),
      callback: function($$v) {
        _vm.$set(_vm.register, "spare", $$v)
      },
      expression: "register.spare"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.RegisterSave()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "margin-top": "-3px"
    },
    attrs: {
      "src": require("../../../assets/icon/钱袋1￥.png")
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#006E4B",
      "font-size": "18px",
      "font-weight": "600"
    }
  }, [_vm._v("履约金信息")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44feb0e2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tender/Performance/manage.vue
// module id = null
// module chunks = 